import Field from "../singleton/field";
import IField from "../interface/field";
import IDocumentsQueryFilter from "../interface/documents-query-filter";
import IDocumentValue from "../interface/document-value";
import FieldType from "../enum/field-type";
import ErrorCode from "../enum/error-code";

export default class DocumentsQueryFilter implements IDocumentsQueryFilter {

    public fieldId: number;

    public value: IDocumentValue;

    public field: IField;

    constructor(params: IDocumentsQueryFilter) {
        const field: IField | null = Field.get(params.fieldId);
        if (field) {
            this.field = field;
            this.fieldId = params.fieldId;
            this.value = params.value;
        } else {
            throw ErrorCode.NoField;
        }
    }

    toString() {
        let fieldId;
        if (this.field.uiType === FieldType.linked) {
            fieldId = `${this.field.linkedRelation[0]}[0]`;
        } else if (this.field.uiType === FieldType.pointer) {
            fieldId = `${this.field.id}[0]`;
        } else {
            fieldId = `${this.field.id}`;
        }
        return `c${fieldId}=\'${this.value}\'`;
    }

}